import React from "react";
import styles from "./styles.module.scss";
import { UICheckBox, UIText } from "src/components/uIKit";
import { useAppSelector } from "src/hooks/useRedux";
import { useIsMobile } from "src/hooks/useIsMobile";

interface CardItemProps {
  image: string;
  digits: string;
  expirationDate: string;
  index: number;
  title?: string;
  isChecked: boolean;
  onCheckboxChange: (index: number) => void;
  ariaLabel?: string;
}

const CardItem: React.FC<CardItemProps> = ({
  image,
  digits,
  expirationDate,
  index,
  title,
  isChecked,
  onCheckboxChange,
  ariaLabel,
}) => {
  const isMobile = useIsMobile();
  const { strings } = useAppSelector((state) => state.app);

  const handleCheckboxChange = () => {
    onCheckboxChange(index);
  };

  return (
    <div className={styles.cardItem} tabIndex={0}>
      
      <UICheckBox checked={isChecked} onChange={handleCheckboxChange} />

      <img src={image} alt={`Card ${index}`} className={styles.image} />
      <div className={styles.cardDetails}>
        {title && (
          <label className="srOnly">{ariaLabel ? ariaLabel : title}</label>
        )}
        <UIText text={strings.t_card_item_card_number} size={15} weight={400} />
        <UIText text={digits} size={18} weight={500} />
      </div>
      <div className={styles.expirationDetails}>
        <UIText
          text={strings.t_card_item_expiration_date}
          size={15}
          weight={400}
          style={styles.label}
        />

        <UIText text={expirationDate} size={18} weight={500} />
      </div>
    </div>
  );
};

export default CardItem;
